import Swiper from '../../../../../vendor/swiper/swiper-bundle.mjs';

export default class AnimalsSlider {
    constructor($el) {
        this.$el = $el;

        this.slide = this.slide.bind(this);
        this.slide();
    }

    slide() {
        new Swiper(this.$el, {
            slidesPerView: 'auto',
            spaceBetween: 100,
            loop: true,
            allowTouchMove: true,
            speed: 6000,
            freeMode: {
                enabled: true,
                momentum: false,
            },
            autoplay: {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
        });
    }
}
